import { defineNuxtRouteMiddleware } from 'nuxt/app'
import { initSharedAppHost } from './locale'

export default defineNuxtRouteMiddleware((to) => {
  return initSharedAppHost(to)
})
